import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Category Register (D-100/D-101) — the single org-scoped category taxonomy. Every category
 * dropdown across the product reads this register by id; no module invents its own list.
 * Shapes here are shared by the API (runtime validation) and the web app (types).
 */
/** The canonical serialized category (GET responses). */
export const categorySchema = z.object({
    id: uuidSchema,
    name: z.string(),
    unspscCode: z.string().nullable(),
    parentId: uuidSchema.nullable(),
    ownerUserId: uuidSchema.nullable(),
    source: z.enum(['manual', 'ai_seeded']),
    isDemo: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** POST /master-data/categories — create by hand (source becomes 'manual'). */
export const createCategorySchema = z
    .object({
    name: z.string().trim().min(1).max(160),
    unspscCode: z.string().trim().max(16).optional(),
    parentId: uuidSchema.optional(),
    ownerUserId: uuidSchema.optional(),
})
    .strict();
/** PATCH /master-data/categories/:id — rename, re-map, re-parent, set owner. */
export const patchCategorySchema = z
    .object({
    name: z.string().trim().min(1).max(160).optional(),
    unspscCode: z.string().trim().max(16).nullable().optional(),
    parentId: uuidSchema.nullable().optional(),
    ownerUserId: uuidSchema.nullable().optional(),
})
    .strict();
//# sourceMappingURL=categories.js.map